import { useEffect, useState } from 'react';
import { Container, Image, Button } from "react-bootstrap";
import {
  FundraisersDetailsSection,
  DetailsWrapper,
  DetailsLeft,
  DetailsRight,
  Title,
  DetailsImage,
  FundraisersDetailsSlider,
  RangeSliderBox,
  LocationBox,
  AddressBox,
  AddressTitle,
  PersonalFundraisersStory,
  StoryDetails,
  StoryLeft,
  StoryRight,
  StoryTitle,
  ContentText,
  StoryProfile,
  ProfileName,
  StoryShare,
  StoryButtonList,
  StoryIcon,
  StoryButtonItem,
  BlueBox,
  BoxTitle,
  BoxText,
  ReadStory,
} from './PersonalFundraisersDetailsStyle'
import LocationIcon from '../../assests/images/bold-location.svg';
import FaceBook from '../../assests/images/facebook.svg';
import TwitterIcon from '../../assests/images/xicon.svg';
import ShareIcon from '../../assests/images/shareicon.svg';
import MailIcon from '../../assests/images/mail.svg';
import NoImage from "../../assests/images/gnp_noimg.png"
import RatingStar from '../../components/common/ratingStar/ratingStar';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { MESSAGE } from '../../utils/message';
import MetaComponent from '../../components/common/metaComponent';
import { openInNewTab } from '../../utils/functions';
import { fundRaiserViewDetailHandler } from '../../redux/slices/myAccount/fundRaiserViewDetail-slice';
import { editFundraiserHandler } from '../../redux/slices/myAccount/manageFundraiser-slice';
import { Slider } from 'antd';
import {
  Dashboard,
  DashboardList,
  DashboardItem,
  ItemTitle,
  ItemNumber,
  ReviewNoCounter,
  ReviewNoCounterSpan,
} from '../../components/common/rangeSlider/rangesliderStyle';

const PersonalFundraisersDetailsView = () => {

  const { id } = useParams()
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const fundRaiserDetail = useSelector((state: any) => state?.fundRaiserViewDetail?.data?.results);
  const reactUrl = import.meta.env.VITE_WEBSITE_URL;
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (fundRaiserDetail?.raised) {
      setValue((fundRaiserDetail?.raised * 100) / fundRaiserDetail?.goal)
    }
  }, [fundRaiserDetail])
  useEffect(() => {
    if (id) {
      dispatch(fundRaiserViewDetailHandler(id))
    }
  }, [])


  const countHandler = async (fb: number, tw: number, em: number, org_id: string, user_id: string) => {
    const data = { "sh_fb": fb, "sh_tw": tw, "sh_em": em };
    await dispatch(editFundraiserHandler(user_id, org_id, data));
    await (id && dispatch(fundRaiserViewDetailHandler(id)));
  }
  const getShareUrl = (platform: any) => {
    const url = `${reactUrl}/personal-fundraisers-details/${id}`;

    switch (platform) {
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
      case 'twitter':
        return `https://twitter.com/intent/tweet?url=${url}`;
      default:
        return '#';
    }
  };

  return (
    <div>
      <MetaComponent
        keywords=""
        description=""
        ogTitle=""
        ogDescription=""
        ogUrl=""
        ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
      />
      <FundraisersDetailsSection>
        <Container className="cont-w">
          <DetailsWrapper>
            <DetailsLeft>
              <Title>{fundRaiserDetail?.title}</Title>
              <FundraisersDetailsSlider>
                <RangeSliderBox>
                  <>
                    <RangeSliderBox>
                      <div className='slider-col'>
                        <Slider value={value} tooltip={{ className: 'custom-tooltip', open: true, formatter: (value) => value + "%" }} />
                      </div>
                    </RangeSliderBox>

                    <Dashboard>
                      <DashboardList className="rage-item">
                        <DashboardItem>
                          <ItemTitle>My Goal</ItemTitle>
                          <ItemNumber>$ {fundRaiserDetail?.goal}</ItemNumber>
                        </DashboardItem>
                        <DashboardItem>
                          <ItemTitle>Raised</ItemTitle>
                          <ItemNumber>$ {fundRaiserDetail?.raised}</ItemNumber>
                        </DashboardItem>
                        <DashboardItem>
                          <ItemTitle>Still Need</ItemTitle>
                          <ItemNumber>$ {fundRaiserDetail?.remain}</ItemNumber>
                        </DashboardItem>
                      </DashboardList>

                      <ReviewNoCounter className="review-no-counter">
                        <ReviewNoCounterSpan>0</ReviewNoCounterSpan> Review
                      </ReviewNoCounter>

                    </Dashboard>
                  </>
                </RangeSliderBox>
                <LocationBox>
                  <AddressBox>
                    <Image src={LocationIcon} />
                    <AddressTitle> {fundRaiserDetail?.address}</AddressTitle> </AddressBox>
                  {fundRaiserDetail?.is_donation && <Button className="donate-now-btn" onClick={() => navigate(`/org/${fundRaiserDetail?.nonprofit_slug}`, { state: { isDonate: true } })}>{MESSAGE.donateNowBtn}</Button>}
                </LocationBox>
              </FundraisersDetailsSlider>
            </DetailsLeft>
            <DetailsRight>
              <DetailsImage> <Image src={fundRaiserDetail?.image ?? NoImage} alt={fundRaiserDetail?.nonprofit} /></DetailsImage>
            </DetailsRight>
          </DetailsWrapper>
        </Container>
      </FundraisersDetailsSection>
      <PersonalFundraisersStory>
        <Container className="cont-w">
          <StoryDetails>
            <StoryLeft>
              <StoryTitle>Story</StoryTitle>
              <ContentText> {fundRaiserDetail?.story}</ContentText>
            </StoryLeft>
            <StoryRight>
              <StoryProfile>
                <Image src={fundRaiserDetail?.
                  nonprofit_logo ?? NoImage} />
                <ProfileName>Every share can raise up to {fundRaiserDetail?.shareRaiseUpto}</ProfileName>
                <StoryShare> <Image src={ShareIcon} />{fundRaiserDetail?.shares} Shares</StoryShare>
                <StoryButtonList>
                  <StoryButtonItem>
                    <Button className='social-btn' onClick={() => { countHandler(parseInt(fundRaiserDetail?.sh_fb) + 1, parseInt(fundRaiserDetail?.sh_tw), parseInt(fundRaiserDetail?.sh_em), fundRaiserDetail?.org_id, fundRaiserDetail?.user_id); openInNewTab(getShareUrl('facebook')); }}><StoryIcon><Image src={FaceBook} /></StoryIcon>Facebook</Button>
                  </StoryButtonItem>
                  <StoryButtonItem>
                    <Button className='social-btn' onClick={() => { countHandler(parseInt(fundRaiserDetail?.sh_fb), parseInt(fundRaiserDetail?.sh_tw) + 1, parseInt(fundRaiserDetail?.sh_em), fundRaiserDetail?.org_id, fundRaiserDetail?.user_id); openInNewTab(getShareUrl('twitter')); }}><StoryIcon><Image src={TwitterIcon} /></StoryIcon>Twitter</Button>
                  </StoryButtonItem>
                  <StoryButtonItem>
                    <Button className='social-btn' onClick={() => { countHandler(parseInt(fundRaiserDetail?.sh_fb), parseInt(fundRaiserDetail?.sh_tw), parseInt(fundRaiserDetail?.sh_em) + 1, fundRaiserDetail?.org_id, fundRaiserDetail?.user_id); window.open("mailto:"); }}><StoryIcon><Image src={MailIcon} /></StoryIcon>Email</Button>
                  </StoryButtonItem>
                </StoryButtonList>
              </StoryProfile>
              <BlueBox>

                <BoxTitle onClick={() => navigate(`/org/${fundRaiserDetail?.nonprofit_slug}`)}>{fundRaiserDetail?.nonprofit}</BoxTitle>
                <BoxText>{fundRaiserDetail?.address}</BoxText>
                <RatingStar review={fundRaiserDetail?.nonprofit_review_count} rating={fundRaiserDetail?.nonprofit_rating} />
                <ReadStory onClick={() => navigate(`/org/${fundRaiserDetail?.nonprofit_slug}`)}>Read stories about {fundRaiserDetail?.nonprofit}</ReadStory>
              </BlueBox>
            </StoryRight>
          </StoryDetails>

        </Container>
      </PersonalFundraisersStory>
    </div>
  )
}

export default PersonalFundraisersDetailsView
